//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Moment from 'moment';

export default {
	name: 'DatePeriodFilter',
	data: function data() {
		return {
			datePeriod: Moment().startOf('month')
		};
	},

	methods: {
		applyFilter: function applyFilter() {
			this.$emit('date-period-change', {
				date_period: this.datePeriod
			});
		},
		exportReport: function exportReport() {
			this.$emit('date-period-export');
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reporting/DatePeriodFilter.vue
// module id = lMh9
// module chunks = 0 1